import { makeStyles } from "@material-ui/core";
import {
  Box,
  CircularProgress,
  CircularProgressProps,
  Dialog,
  Typography,
  circularProgressClasses,
} from "@mui/material";
import { useEffect, useState } from "react";

export default ({ open, title }) => {
  const classes = useStyles();

  const [progress, setProgress] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      if (open) {
        setProgress((prevProgress) => (prevProgress >= 90 ? 99 : prevProgress + 10));
      }
    }, 1500);
    return () => {
      clearInterval(timer);
    };
  }, [open]);

  const getText = ()=>{
    if (progress <= 30) {
      return "Please wait while we upload your document for processing."
    }
    if (progress > 30 && progress <=80) {
      return "Our AI is currently reading and interpreting the content."
    }
    if (progress >80) {
      return "It'll be done in a few seconds."
    }
  }

  return (
    <>
      {/* <Dialog open={open} className={`${classes.dialog} submitLoader`}> */}
      {open && (
        <Box className={classes.container}>
          <Box className={classes.root}>
            {/* <ProgressBar /> */}
            <CircularProgressWithLabel value={progress} />
            <Typography className={classes.title}>
              {title ??
                // "Please wait while we upload your document for processing."
                getText()
                }
            </Typography>
          </Box>
        </Box>
      )}
      {/* </Dialog> */}
      <style>{`
            .submitLoader .MuiDialog-paper {
                max-width: 100%;
                border-radius: 24px !important
               
            }
            @media(max-width:400px){
                .submitLoader .MuiDialog-paper {
                    max-width: 100%;
                    border-radius: 24px !important;    
                    // min-height:22vh ;
                }
            }
        `}</style>
    </>
  );
};

const ProgressBar = (props) => {
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) => theme.palette.secondary.main,
        }}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: "white !important",
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  );
};

const CircularProgressWithLabel = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate"
        sx={{
          color: (theme) => theme.palette.secondary.main,
        }}{...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  dialog: {
    maxWidth: "100%",
    overflow: "hidden",
  },
  container: {
    width: "100%",
    height: "100%",
    position: "fixed",
    background: "rgba(0, 0, 0, 0.5)",
    zIndex: "100",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    top: 0,
    left: 0,
  },
  root: {
    boxSizing: "border-box",
    // width: "90%",
    padding: 32,
    backgroundColor: "#4C4C4C",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 24,
    borderRadius: "20px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      padding: 26,
      gap: 20,
    },
  },
  title: {
    fontSize: "20px !important",
    color: "#fff",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px !important",
    },
  },
}));
